module.exports = __webpack_public_path__ + "img/introduce-img.457b60eb.jpg";